
import { atom } from "recoil"

export const AtomCurrentFontAvailable = atom({
    key:'ATOMCURRENTFONTAVAILABLE',
    default:[]
})